import { render, staticRenderFns } from "./followUp.vue?vue&type=template&id=a7179e84&scoped=true"
import script from "./followUp.vue?vue&type=script&lang=js"
export * from "./followUp.vue?vue&type=script&lang=js"
import style0 from "./followUp.vue?vue&type=style&index=0&id=a7179e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7179e84",
  null
  
)

export default component.exports